import isSameDay from 'date-fns/isSameDay';
import isToday from 'date-fns/isToday';
import isWithinInterval from 'date-fns/isWithinInterval';
import formatDate from 'utils/formatDate';
import React, { Component } from 'react';
import classnames from 'classnames';
import {WithTrekker} from 'utils/analytics'

const CSS = require('./Day.less');

interface DayProps {
  startDate: Date;
  endDate: Date;
  day: number;
  date: Date;
  disabled: boolean;
  marked: boolean;
  onSelect: (e: Date) => void;
}

class Day extends Component<DayProps, any> {
  onUpdateDate = () => {
    if (!this.props.disabled) {
      this.props.onSelect(this.props.date);
    }
  };

  render() {
    const { day } = this.props;
    if (day === 0) {
      return (
        <div className={CSS.day}/>
      );
    }

    const { date, startDate, endDate, disabled, marked } = this.props;
    const startIsSameAsEnd = isSameDay(startDate, endDate);
    return (
      <WithTrekker>
        {(trekker) =>(
          <div
            className={classnames(
              CSS.day
            )}
            aria-label={disabled ? '' : formatDate(date, 'yyyy-MM-dd')}
            data-date={day === 0 ? 'dummy' : formatDate(date, 'yyyy-MM-dd')}
            onClick={trekker.track('click', this.onUpdateDate as any, {component: ['day-selector'], selectedValue: formatDate(date, 'yyyy-MM-dd')})}
          >
            <span
              className={classnames(CSS.DaySpan,
                {
                  [CSS.DayBefore]: disabled,
                  [CSS.DayToday]: isToday(date),
                  [CSS.DaySelected]: !endDate ? isSameDay(date, startDate) : isWithinInterval(date, { start: startDate, end: endDate }),
                  [CSS.DaySelectedStart]: !!endDate && isSameDay(date, startDate) && !startIsSameAsEnd,
                  [CSS.DaySelectedEnd]: !!startDate && isSameDay(date, endDate) && !startIsSameAsEnd,
                  [CSS.DaySelectedMulti]: !!endDate && isWithinInterval(date, { start: startDate, end: endDate }) && !startIsSameAsEnd && !isSameDay(date, startDate) && !isSameDay(date, endDate),
                  [CSS.DayMarked]: marked,
                })}
            >
              {day}
            </span>
          </div>
        )}
      </WithTrekker>
    );
  }
}

export default Day;
